<div class="container-fluid">
  <page-header-breadcrumb
  [pageTitleValue]="pageTitle"
  [pageLinkValue]="'/specialties'"
  [currentPageValue]="editMode ? 'Edit Speciality' : 'Add Speciality'"
></page-header-breadcrumb>

  <div class="card mb-4">
    <div class="card-body">
      <form
        [formGroup]="addSpecialityForm"
        (ngSubmit)="onAddSpecialitySubmit()"
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="speciality-name">
                Specialty Name
              </label>
              <input
                class="form-control"
                id="speciality-name"
                formControlName="enSpecialityName"
                placeholder="Specialty Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addSpecialityForm.controls.enSpecialityName.dirty) &&
                  addSpecialityForm.controls.enSpecialityName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addSpecialityForm.controls.enSpecialityName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addSpecialityForm.controls.enSpecialityName.errors.pattern">
                  This field accept only english characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="speciality-name">
                Specialty Arabic Name
              </label>
              <input
                class="form-control"
                id="speciality-name"
                formControlName="arSpecialityName"
                placeholder="Specialty Arabic Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addSpecialityForm.controls.arSpecialityName.dirty) &&
                  addSpecialityForm.controls.arSpecialityName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addSpecialityForm.controls.arSpecialityName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addSpecialityForm.controls.arSpecialityName.errors.pattern">
                  This field accept only arabic characters!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex align-items-center">
            <label class="mr-6 mb-0" for="active-check">isActive?</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                checked="checked"
                type="checkbox"
                id="active-check"
                formControlName="specialityActiveCheck"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
          <div class="col d-flex align-items-center">
            <label class="mr-6 mb-0" for="anon-check">Anonymous?</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                checked="checked"
                type="checkbox"
                id="anon-check"
                formControlName="specialityAnonymousCheck"
                [(ngModel)]="specialityData.isAnonymous"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="rankFormControl">
                Rank
              </label>
              <select
                formControlName="specialityRank"
                class="form-control"
                id="rankFormControl"
              >
                <option
                  *ngFor="let item of ranks; let i = index"
                  [value]="i + 1"
                >
                  {{ i + 1 }}
                </option>
              </select>
              <div
                *ngIf="isSubmited && addSpecialityForm.controls.specialityRank.errors"
                class="input-errors"
              >
                <p *ngIf="addSpecialityForm.controls.specialityRank.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <!-- <br /> -->
              <div class="custom-file">
                <input
                  (change)="onImageUpload($event)"
                  class="custom-file-input"
                  id="specialty-image"
                  lang="en"
                  type="file"
                />
                <label class="custom-file-label" for="specialty-image">
                  {{ specialityFileName || "Select specialty image" }}
                </label>
                <input
                  type="hidden"
                  name="fileHidden"
                  formControlName="specialityFileInput"
                />
                <div
                  *ngIf="isSubmited && addSpecialityForm.controls.specialityFileInput.errors"
                  class="input-errors"
                >
                  <p *ngIf="addSpecialityForm.controls.specialityFileInput.errors.required">
                    This field is required!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <!-- <br /> -->
              <div class="custom-file">
                <input
                  (change)="onFeaturedSpecialityImageUpload($event)"
                  class="custom-file-input"
                  id="specialty-featured-image"
                  lang="en"
                  type="file"
                />
                <label class="custom-file-label" for="specialty-featured-image">
                  {{ specialityFeaturedImageName || "Select specialty featured image" }}
                </label>
                <input
                  type="hidden"
                  name="fileHidden"
                  formControlName="specialityFeaturedImage"
                />
                <div
                  *ngIf="isSubmited && addSpecialityForm.controls.specialityFeaturedImage.errors"
                  class="input-errors"
                >
                  <p *ngIf="addSpecialityForm.controls.specialityFeaturedImage.errors.required">
                    This field is required!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
            >
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/specialties'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
